import { _LOGIN_SUCCESS, _LOGIN_FAILED, _LOGOUT, _ACTION_FORBIDDEN, _SET_PENDING_TNC } from './AuthAction';
import { clearPermissionData } from "../util/PermissionChecker"
import { SessionKey } from "../util/Constant";

const _INITIAL_STATE = {
    userData: {},
    pendingTNC: false,
    isLoggedIn: false,
    loginMessage: "",
    loginStateInitialized: false,
    isForbidden: false
};

/// <summary>
/// Author: -
/// </summary>
export default (state = _INITIAL_STATE, action) => {
    switch (action.type) {
        case _LOGIN_SUCCESS:
            sessionStorage.setItem(SessionKey._LOGIN_GUID, action.userData.userId);
            localStorage.setItem(SessionKey._LOGIN_GUID, action.userData.userId);

            return {
                ...state,
                userData: action.userData,
                isLoggedIn: true,
                loginMessage: "",
                loginStateInitialized: true
            }
            break;
        case _LOGIN_FAILED:
            return {
                loginMessage: action.message,
                isLoggedIn: false,
                userData: {},
                loginStateInitialized: true
            }
            break;
        case _LOGOUT:
            clearPermissionData();
            return {
                userData: {},
                isLoggedIn: false,
                loginMessage: "",
                loginStateInitialized: true,
                creditLimit: 0
            };
            break;
        case _ACTION_FORBIDDEN:
            return {
                ...state,
                isForbidden: action.value
            };
            break;
        case _SET_PENDING_TNC:
            return {
                ...state,
                pendingTNC: action.status
            };
            break;
        default:
            return state;
            break;
    }
};
